import React from "react";
import Header3 from "../components/Header3";
import Footer from "../components/Footer";

const Works = () => {
  return (
    <>
      <div className=" d-flex flex-column" style={{ height: "100vh" }}>
        <Header3 />
        <div className="flex-grow-1">
          <div
            className=" fs-3 martext mt-4 "
            style={{
              fontFamily: "Open Sans",
              fontWeight: "700",
              lineHeight: "40px",
              color: "#3B3B3B",
            }}
          >
            How it works
          </div>
          <div className="fw-normal martext1 fs-5 mt-sm-2  ftzevtt   ">
            Welcome to Ofellio, a free platform designed for anyone looking to
            connect with others and share thoughts and feelings inspired by a
            book. <br /> <br /> No matter your level of reading experience,
            whether you are a passionate bookworm, an occasional reader, or
            someone just looking for a meaningful meet-up, Ofellio is the place
            for you. It is more than just books—Ofellio is a gateway to{" "}
            <span className="fw-bold">community, friendship, </span>
            and <span className="fw-bold">real connections.</span>
          </div>
          <div
            className=" fs-3 martext mt-4 "
            style={{
              fontFamily: "Open Sans",
              fontWeight: "700",
              lineHeight: "40px",
              color: "#3B3B3B",
            }}
          >
            What Ofellio offers
          </div>

          <div
            className=" fs-3 fw-bold martext mt-4 "
            style={{
              lineHeight: "40px",
            }}
          >
            Book Club{" "}
          </div>
          <div className="fw-normal martext1 fs-5 mt-sm-2  ftzevtt   ">
            Discover real-life book clubs in your area, hosted in a snug setting
            such as cafes, bars or a welcoming venue. Each Ofellio Book Club
            welcomes up to 8 participants, sorted by age to offer a more
            comfortable and engaging experience. The discussion will be
            facilitated by an Ambassador, ensuring a lively and inclusive
            atmosphere.
            <br /> <br /> You can join as many Book Clubs as you like, there are
            no limits: explore the{" "}
            <span className="text-decoration-underline">
              Book Clubs available near you!
            </span>
          </div>
          <div
            className=" fs-3 fw-bold martext mt-4 "
            style={{
              lineHeight: "40px",
            }}
          >
            Book Duo{" "}
          </div>
          <div className="fw-normal martext1 fs-5 mt-sm-2  ftzevtt   ">
            Do you prefer a more personal connection? A Book Duo is perfect for
            you! Simply pick a book of your choice, select the gender and age
            range of the partner you would like to connect with and you are all
            set! Once someone will show interest, you will start a chat and
            arrange the details of your meeting.
            <br /> <br />
            <span className="text-decoration-underline">
              Create or join a Book Duo
            </span>{" "}
            in your area!
          </div>

          <div
            className=" fs-3 fw-bold martext mt-4 "
            style={{
              lineHeight: "40px",
            }}
          >
            Silent reading
          </div>
          <div className="fw-normal martext1 fs-5 mt-sm-2  ftzevtt   ">
            Held in a relaxing and comfortable setting, Silent Readings offer a
            peaceful escape for up to 10 readers. Led by an Ambassador, each
            session invites you to bring your own book, read quietly, and
            optionally connecting with others in a relaxed atmosphere.
            <br /> <br />
            Explore the{" "}
            <span className="text-decoration-underline">
              Silent Readings available near you
            </span>{" "}
            and enjoy a stress-free experience today!
          </div>

          <div className="fw-normal martext1 fs-5 mt-md-5 mt-sm-4  mb-5  ftzevtt   ">
            A meaningful conversation over a book is just a click away!
          </div>
        </div>

        <div className="workfooter">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Works;
